import { HudButton } from 'components/HudButton'
import { Eye } from 'lucide-react'
import React, { Dispatch, FC, SetStateAction } from 'react'

interface ObservationButtonProps {
  isSelected: boolean
  setIsSelected: Dispatch<SetStateAction<boolean>>
}

export const ObservationButton: FC<ObservationButtonProps> = (props) => {
  return (
    <HudButton
      icon={<Eye />}
      isSelected={props.isSelected}
      onClick={() => props.setIsSelected(!props.isSelected)}
      animation='scale'
      scaleAmount={1.1}
    />
  )
}
